export default "__VITE_ASSET__Cu1mwlJ0__"